import { render } from "./qr.vue?vue&type=template&id=79f9fa40"
import script from "./qr.vue?vue&type=script&lang=js"
export * from "./qr.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__